// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__3kA2e","modalBody":"Modal_modalBody__3e_3V","close_modal":"Modal_close_modal__1pXaI"};